import classnames from 'classnames';
import React from 'react';

import css from 'reactComponents/icons/defaultIconStyles.css';

export function IconPhone({ width = '16', height = '16', className, ...rest }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={classnames(css.main, className)}
            {...rest}
        >
            <path
                d="M6.601.693a1.23 1.23 0 0 1 1.507.874l.663 2.484a1.237 1.237 0 0 1-1.017 1.544l-1.171.24s-.702.103-.684.806c.021.89 1.503 3.468 2.26 3.932.598.366 1.037-.193 1.037-.193l.793-.898a1.229 1.229 0 0 1 1.84-.112l1.811 1.819a1.24 1.24 0 0 1 0 1.747s-1.082 1.133-2.425 1.956c-1.614.99-3.155.102-3.643-.144-1.148-.581-2.727-2.431-3.771-4.213l-.049-.085c-1.015-1.799-1.82-4.098-1.747-5.385.031-.548.036-2.332 1.696-3.241 1.382-.757 2.9-1.131 2.9-1.131z"
                className={css.colored}
            />
        </svg>
    );
}

export default IconPhone;
